export default __webpack_public_path__ + "static/kaiser-0de2424eeba3c8a66f87c5cdd77ae564.jpg";